import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path d="M4.5 0H7V18H4.5z"></path>
          <path d="M0 14H2.5V32H0z" transform="rotate(-90 0 14)"></path>
        </svg>
    );
}